import { Grid } from "@mui/material";
import useModal from "@rf/base/modal/useModal";
import React from "react";
import MxModalHeader from "./MxModalHeader";

interface IMxModalTemplate2Props {
  children?: React.ReactNode;
}
const MxModalTemplate2 = (props: IMxModalTemplate2Props) => {
  const { getOptions } = useModal();

  return (
    <Grid container rowGap={2}>
      <Grid item xs={12}>
        <MxModalHeader />
      </Grid>
      <Grid item xs={12}>
        {props.children}
      </Grid>
    </Grid>
  );
};

export default MxModalTemplate2;
